import React from 'react';

const STEPS = ['Dados', 'Perfil', 'Necessidade', 'Atendimento'];

export const QuestionarioCasasProgress = ({ step }) => {
  return (
    <div className="mb-8" data-testid="questionario-casas-progress-wrapper">
      <div className="flex justify-between mb-2 text-xs sm:text-sm font-medium text-gray-500" data-testid="questionario-casas-progress-labels">
        {STEPS.map((label) => (
          <span key={label}>{label}</span>
        ))}
      </div>
      <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-testid="questionario-casas-progress-bar-bg">
        <div className="h-full bg-blue-600 transition-all duration-300" style={{ width: `${(step / 4) * 100}%` }} data-testid="questionario-casas-progress-bar-fill" />
      </div>
    </div>
  );
};
